import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { MatIcon, MatIconRegistry } from "@angular/material/icon";
import { SessionService } from '../../session.service';
import { Auth } from '@angular/fire/auth';
import { DialogRef } from '@angular/cdk/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'soph-session-expired-modal',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, MatButton, MatIcon],
  templateUrl: './session-expired-modal.component.html',
  styleUrl: './session-expired-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionExpiredModalComponent {
  private readonly iconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

  private readonly _sessionService = inject(SessionService);
  private readonly _auth = inject(Auth);
  private readonly _dialogRef = inject(DialogRef);
  private readonly _cdr = inject(ChangeDetectorRef);

  private remainingTime: number = 0;
  private intervalId: any;

  get minutes(): string {
    const min = Math.floor(this.remainingTime / 1000 / 60);
    return min < 10 ? '0' + min : '' + min;
  }

  get seconds(): string {
    const sec = Math.floor((this.remainingTime / 1000) % 60);
    return sec < 10 ? '0' + sec : '' + sec;
  }

  constructor() {
    this._sessionService.sessionLogout$.subscribe(() => {
      this._dialogRef.close();
    });

    this.iconRegistry.addSvgIcon(
      'timer',
      this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/timer.svg`)
    )
  }

  ngOnInit() {
    this.updateRemainingTime();
    this.intervalId = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }

  updateRemainingTime() {
    this.remainingTime = this._sessionService.getRemainingSessionTimeMs();
    this._cdr.markForCheck();
  }

  protected cerrarSesion(): void {
    this._sessionService.logout();
    this._dialogRef.close();
  }

  protected continuarSesion(): void {
    this._auth.currentUser?.getIdToken(true).then((token) => {
      this._sessionService.setSession(token);
      this._dialogRef.close();
    });
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
